import BizTextArea from '../../Mini/BizTextArea';
import { FormFieldComponentProps } from './fieldProps';

const TextAreaField = ({ field, value, disabled, onChange, onBlur }: FormFieldComponentProps) => {
	return (
		<>
			{field.label && <div className='biz-form-field__label'>{field.label}</div>}
			<BizTextArea
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onBlur={onBlur}
				placeholder={field.placeholder}
				readonly={disabled}
			/>
		</>
	);
};

export default TextAreaField;
